export default __webpack_public_path__ + "static/media/datosValidos.4ca9d4d0.svg";